module.exports = __webpack_public_path__ + "img/vertical_3_3_7042.05770192.png";